import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';
import { crypto as cryptoData } from './data';
import { CalsoftMockApi } from 'src/app/global/mock-api/mock-api.interfaces';
import { CalsoftMockApiService } from 'src/app/global/mock-api/mock-api.service';

@Injectable({
    providedIn: 'root'
})
export class CryptoMockApi implements CalsoftMockApi
{
    // Private
    private _crypto: any;

    /**
     * Constructor
     *
     * @param _calsoftMockApiService
     */
    constructor(
        private _calsoftMockApiService: CalsoftMockApiService
    )
    {
        // Set the data
        this._crypto = cryptoData;

        // Register the API endpoints
        this.register();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register
     */
    register(): void
    {
        // -----------------------------------------------------------------------------------------------------
        // @ Crypto - GET
        // -----------------------------------------------------------------------------------------------------
        this._calsoftMockApiService
            .onGet('api/dashboards/crypto')
            .reply(() => {

                return [
                    200,
                    _.cloneDeep(this._crypto)
                ];
            });
    }
}
